import { useSelectionContext } from 'Components/UI/ListDetailView/SelectionContext';
import { useListContext } from 'Components/UI/ListDetailView/ListContext';

import {
  deleteResource,
  refreshList,
  selectResource,
  submitListResource,
  unselectResource,
  updateListResource,
} from './Actions';

export default function useListDetailActions() {
  const {
    dispatch: selectionDispatch,
    state: selectionState,
  } = useSelectionContext();

  const { dispatch: listDispatch, state: listState } = useListContext();

  return {
    deleteResource: resource => {
      return deleteResource(
        selectionDispatch,
        selectionState,
        listDispatch,
        resource,
      );
    },
    selectResource: (resource, collection) => {
      return selectResource(
        selectionDispatch,
        selectionState,
        resource,
        collection,
      );
    },
    updateListResource: updatedResource => {
      return updateListResource(listDispatch, updatedResource);
    },
    submitListResource: resource => {
      return submitListResource(listDispatch, listState, resource, {
        actionName: 'updateResource',
      });
    },
    unselectResource: () => {
      return unselectResource(selectionDispatch, selectionState);
    },
    refreshList: () => {
      return refreshList(listDispatch, listState);
    },
  };
}
